import React, { useEffect, useState, useMemo} from "react";
import "./job-tree.css";
import DetailBloc from '../Blocs/DetailBloc';
import apiResponse from "../../../../../services/apiResponse";

// Komponen rekursif node
const TreeNode = ({
  node,
  level,
  expandedIds,
  toggleExpand,
  selectedId,
  onSelect,
}) => {
  const isExpanded = expandedIds.includes(node.id);
  const isLeaf = !node.hasChildren || !node.children || node.children.length === 0;

  // bar/row untuk grup (punya anak)
  if (!isLeaf) {
    return (
      <div className="jt-node-group">
        <div
          className={`jt-group-header jt-group-level-${level}`}
          onClick={() => {
            toggleExpand(node);
            onSelect(node); 
          }}
        >
          <span className="jt-caret">
            {isExpanded ? "▾" : "▸"}
          </span>
          <span className="jt-group-label">{node.label}</span>
        </div>

        {isExpanded && (
          <div className="jt-group-children">
            {node.children.map((child) => (
              <TreeNode
                key={child.id}
                node={child}
                level={level + 1}
                expandedIds={expandedIds}
                toggleExpand={toggleExpand}
                selectedId={selectedId}
                onSelect={onSelect}
              />
            ))}
          </div>
        )}
      </div>
    );
  }

  // row untuk leaf (jabatan terakhir)
  const isSelected = selectedId === node.id;

  return (
    <div
      className={
        "jt-leaf-row" +
        (isSelected ? " jt-leaf-selected" : "")
      }
      onClick={() => onSelect(node)}
    >
      <div className="jt-leaf-icon">
        {/* Contoh: huruf pertama dari label sebagai icon.
            Kalau mau pakai F/P bisa ganti logic di sini */}
        <span>{node.label?.charAt(0) || "J"}</span>
      </div>
      <div className="jt-leaf-label">{node.label}</div>
    </div>
  );
};



const TreeSkeleton = () => {
    return (
      <div className="jt-skeleton">
        {[...Array(13)].map((_, i) => (
          <div key={i} className="jt-skeleton-row">
            <div className="jt-skeleton-icon shimmer" />
            <div className="jt-skeleton-bar shimmer" />
          </div>
        ))}
      </div>
    );
  };
  


const JobTreeComponent = ({onSelectUuid}) => {
let detailBloc = useMemo(() => new DetailBloc(), []);

  const [treeData, setTreeData] = useState([]);
  const [expandedIds, setExpandedIds] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentUuid, setCurrentUuid] = useState(null);


  useEffect(() => {
    // get data unit
    const subscription =  detailBloc.treeHirarkiChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          setLoading(true);
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            setTreeData(response);
            setLoading(false);
            fetchTree();
          }
          break;
        case apiResponse.ERROR:
          setLoading(false);
          break;
        default:
          break;
      }
      });

    detailBloc.fetchTreeHirarki({});

    return () => {
      console.log("unmount");
      subscription.unsubscribe();   
      // detailBloc.treeHirarkiChannel?.unsubscribe();
    };
  },[])//[onSelectUuid]);

  const fetchTree = async () => {
    try {
    //  const { data } = treeData; 

      // Optional: auto expand level 2 (root) & level 3
      const initialExpanded = [];
      const walk = (node) => {
        if (node.hasChildren && (node.levels <= 3)) {
          initialExpanded.push(node.id);
        }
        (node.children || []).forEach(walk);
      };
      (treeData || []).forEach(walk);
      setExpandedIds(initialExpanded);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const toggleExpand = (node) => {
    const id = node.id;

    setExpandedIds((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
    setSelectedId(id);
    onSelectUuid({
      type: 'work_unit',
      uuid: id,
      label: node.label
    });
  };




  const handleSelect = (node) => {
    setSelectedId(node.id);
    if (node.isPosition) {
      console.log('position')
      onSelectUuid({
        type: 'position',
        workUnitUuid: node.workUnitUuid,
        positionUuid: node.id,
        label: node.label
      });
    } else {
      onSelectUuid({
        type: 'work_unit',
        workUnitUuid: node.workUnitUuid,
        label: node.label
      });
    }
  };



  if (loading) {
    return (
      <div className="jt-container">
        <TreeSkeleton />
      </div>
    );
  }

  if (!treeData.length) {
    return <p>Tidak ada data.</p>;
  }





  return (
    <div className="jt-container">
      {treeData.map((root) => (
        <TreeNode
          key={root.id}
          node={root}
          level={1}
          expandedIds={expandedIds}
          toggleExpand={toggleExpand}
          selectedId={selectedId}
          onSelect={handleSelect}
        />
      ))}
    </div>
  );
};

export default JobTreeComponent;
